/**
 * 全局状态管理
 */

import { reactive, readonly } from 'vue'
import { getLocUserInfo, setUserMenu, getUserMenu, setComdCt, getComdCt, setLocUserInfo } from '@/utils/storage'

/**
 * 用户信息状态
 */
export const userInfo = reactive<any>(getLocUserInfo() || {})

  console.log("全局用户信息", userInfo);
/**
 * 设置用户信息
 */
export function setUserInfo(data: any) {
  // 逐个赋值给 userInfo
  Object.keys(data).forEach(key => {
    userInfo[key] = data[key]
  })
  setLocUserInfo(userInfo)
  // 同步更新到 request.ts 中的 userInfo（用于 API 请求）
  // updateRequestUserInfo(data)
}

/**
 * 更新 request.ts 中的用户信息
 */
function updateRequestUserInfo(data: any) {
  // 由于 request.ts 中的 userInfo 是常量，我们需要通过 localStorage 来同步
  // 当 setLocUserInfo 被调用时，localStorage 已经更新
  // request.ts 会在下次请求时从 localStorage 重新读取
}

/**
 * 登出
 */
export function logout() {
  Object.keys(userInfo).forEach((key) => {
    delete userInfo[key]
  })
  localStorage.clear()
}

/**
 * 全局分页状态
 */
export const pagination = reactive({
  page: 0,
  size: 20
})

/**
 * 设置分页
 */
export function setPagination(p: number, s?: number) {
  pagination.page = p
  if (s !== undefined) {
    pagination.size = s
  }
}

/**
 * 钱包配置
 */
export const walletOptions = {
  toRmb: '0.01', // 1 系统币 = 0.01 RMB
  积分: '100' // 1 RMB = 100 系统币
}

/**
 * 图片基础 URL
 */
export function getImgReadUrl(): string {
  return import.meta.env.VITE_IMG_READ_URL || 'https://imgs.promise.pink/'
}

/**
 * 图片上传 URL
 */
export function getImgUploadUrl(): string {
  return import.meta.env.VITE_IMG_UPLOAD_URL || 'https://api-devs.promise.pink/upload/'
}

/**
 * 拼接完整图片 URL
 */
export function buildImgUrl(imgPath?: string): string {
  if (!imgPath) return ''
  const baseUrl = getImgReadUrl()
  const base = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`
  const path = imgPath.startsWith('/') ? imgPath.substring(1) : imgPath
  return `${base}${path}`
}

/**
 * 菜单状态
 */
export const menuState = reactive({
  list: getUserMenu() || [],
  collapsed: false
})

/**
 * 设置菜单
 */
export function setMenuList(data: any[]) {
  menuState.list = data
  setUserMenu(data)
}

/**
 * 切换菜单折叠状态
 */
export function toggleMenuCollapsed() {
  menuState.collapsed = !menuState.collapsed
}

/**
 * 商品分类状态
 */
export const categoryState = reactive({
  list: getComdCt() || []
})

/**
 * 设置商品分类
 */
export function setCategoryList(data: any[]) {
  categoryState.list = data
  setComdCt(data)
}

// 导出状态和方法
export const useGlobalStore = () => ({
  userInfo,
  pagination,
  walletOptions,
  menuState,
  categoryState
})

// 注意：所有函数已经在上面单独 export，不需要在此重复导出
